import Image from 'next/image';
import { Badge } from './ui/badge';
import { useTranslation } from '../hooks/useTranslation';

export default function PokemonFeaturesTwo() {
  const { t } = useTranslation();

  // Pokemon-specific features
  const features = [
    {
      name: 'Browse by set',
      description: 'Explore Pokemon cards organized by set, from Base Set to the latest expansions.',
    },
    {
      name: 'Search by type',
      description: 'Find Pokemon cards by type, including Fire, Water, Grass, and more.',
    },
    {
      name: 'Filter by rarity',
      description: 'Filter Pokemon cards by rarity, from Common to Ultra Rare and Secret Rare.',
    },
  ];

  return (
    <div className='relative overflow-hidden py-24 sm:py-32'>
      <div className='relative mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2'>
          <div className='lg:mr-auto lg:pt-4'>
            <div className='lg:max-w-lg'>
              <Badge variant='primary'>Advanced Search</Badge>
              <h2 className='mt-6 text-3xl font-bold tracking-tight text-gray-900 !leading-snug sm:text-4xl dark:text-gray-50'>Find any Pokemon card with powerful search tools</h2>
              <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-400'>Our advanced search tools make it easy to find exactly the Pokemon cards you&apos;re looking for.</p>
              <dl className='mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none'>
                {features.map((feature) => (
                  <div key={feature.name} className='relative transition-all duration-200 hover:translate-x-1'>
                    <dt className='inline font-semibold text-gray-900 dark:text-gray-50'>
                      <div className='absolute left-0 top-1 size-6 flex items-center justify-center rounded-lg bg-yellow-500/10'>
                        <div className='size-2 rounded-full bg-yellow-500'></div>
                      </div>
                      {feature.name}
                    </dt>
                    <dd className='inline ml-2 text-gray-600 dark:text-gray-400'>{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>

          <div className='flex items-start justify-start lg:order-last'>
            <div className='relative'>
              <div className='absolute -inset-4'>
                <div className='mx-auto w-full h-full max-w-4xl bg-gradient-to-r from-blue-500/30 to-yellow-500/30 blur-3xl opacity-20'></div>
              </div>
              <div className='relative w-[48rem] h-[30rem] max-w-none rounded-xl shadow-2xl ring-1 ring-gray-400/10 transition-all duration-300 hover:scale-[1.01] sm:w-[57rem] overflow-hidden'>
                <Image 
                  src='/pokemon-card-search.png' 
                  alt='Pokemon card search interface with filtering options' 
                  fill
                  className='object-cover'
                  priority
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
